import React from 'react';
import { shallow } from 'enzyme';
import Review360View from '../views/Review360View';

describe('Review360View', () => {
  it('hides stale user form content while the other-user data is still loading', () => {
    const wrapper = shallow(<Review360View />, {
      disableLifecycleMethods: true,
    });

    wrapper.setState({
      reviewTab: 'others',
      isLoadingUsers: true,
      isLoadingSections: true,
      goalCycleList: [{ id: 'cycle-1', title: 'Cycle 1' }],
      selectedGoalCycle: { id: 'cycle-1', title: 'Cycle 1' },
      userList: [{ id: 'user-2', name: 'Jane Doe', initials: 'JD', is_submitted: false }],
      selectedUser: { id: 'user-2', name: 'Jane Doe', initials: 'JD', is_submitted: false },
      sections: [
        {
          id: 'section-1',
          title: 'Performance',
          questions: [{
            id: 'question-1',
            feedback_question_id: 'feedback-1',
            title: 'How was the delivery?',
            answer_type: 'rating_scale',
          }],
        },
      ],
      answers: {},
      selfFeedbackStatus: { is_submitted: false, self_feedback_available: true },
    });

    expect(wrapper.text()).toContain('Loading users...');
    expect(wrapper.text()).not.toContain('Provide 360° feedback for Jane Doe');
  });
});
